/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Memoizes the resultFunc in a dependent selector (see createSelector)
 */

import { shallowEqual } from 'react-redux'

import { Selector } from './types'

export const memoizeResultsFunc = <Args extends any[], Result>(
  selector: Selector<Args, Result>
): Selector<Args, Result> => {
  let prevArgs: Args
  let prevValue: Result

  return (...args: Args) => {
    const isEqual = prevArgs && shallowEqual(args, prevArgs)
    if (!isEqual) {
      const value = selector(...args)
      prevArgs = args
      prevValue = value
    }
    return prevValue
  }
}
